import { useEffect } from "react";
import { Button, Card } from "antd";

function HalamanLunas({ detailInvoice }) {
    // 🔁 Redirect otomatis setelah 3 detik
    useEffect(() => {
        const timer = setTimeout(() => {
            window.location.href = "https://ihore.id";
        }, 3000); // 3000 ms = 3 detik

        return () => clearTimeout(timer); // bersihkan timer jika komponen unmount
    }, []);

    return (
        <Card className="max-w-xl text-center shadow-md p-6 bg-green-50">
            <h2 className="text-2xl font-semibold text-green-700">
                ✅ Pembayaran Lunas
            </h2>
            <p className="text-gray-600 mt-2">
                Terima kasih! Tagihan internet Anda untuk bulan{" "}
                <strong>{detailInvoice?.bulan_tagihan}</strong> tahun{" "}
                <strong>{detailInvoice?.tahun_tagihan}</strong> sudah lunas.
            </p>
            <p className="text-sm text-gray-500 mt-4">
                Anda akan diarahkan ke halaman utama dalam beberapa detik...
            </p>

            <div className="mt-6">
                <Button
                    type="primary"
                    className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-2 rounded-md shadow-md transition duration-300 ease-in-out"
                    onClick={() => (window.location.href = "https://ihore.id")}
                >
                    Keluar Sekarang
                </Button>
            </div>
        </Card>
    );
}

export default HalamanLunas;
